<template>
  <component
    :is="getFieldEditorComponent(fieldType)"
    :field-key="fieldKey"
    :ref="fieldKey"
    :field-select-items="fieldSelectItems"
    v-model="localValue"
    @input="handleOnInput"
  ></component>
</template>

<script>
import { BaseFieldMixin } from './BaseFieldMixin'
import PlainTextField from '@/components/FieldEditors/PlainTextField'
import SelectBoxSingleValueField from '@/components/FieldEditors/SelectBoxSingleValueField'
import Enums from '@/helpers/Enums'

export default {
  name: 'UniversalFieldEditor',
  mixins: [BaseFieldMixin],
  props: {},
  data: function() {
    return {
      localValue: null
    }
  },
  mounted() {
    if (
      typeof this.fieldKey === 'string' &&
      this.fieldKey === 'apartmentTourUrl'
    ) {
      this.localValue = this.value
      return
    }

    if (typeof this.value === 'string') {
      this.localValue = this.value.toLowerCase()
    } else {
      this.localValue = this.value
    }
  },
  methods: {
    getFieldEditorComponent: function(fieldType) {
      let retComponent = PlainTextField
      switch (this.fieldType) {
        case Enums.FieldEditorType.selectBoxSingleValue: {
          retComponent = SelectBoxSingleValueField
          break
        }
        default:
          console.warn('UniversalFieldEditor unknown field type', fieldType)
      }
      return retComponent
    },
    handleOnInput: function(param) {
      this.$emit('input', param)
    }
  }
}
</script>

<style scoped></style>
